import React, { Component } from 'react'
import $ from 'jquery'
import Pagination from './Pagination.jsx';
import { apiClient } from "../helpers/common";
import { ToastContainer, toast } from 'react-toastify';

class UserInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            age: '',
            gender: '',
            name: '',
            phone: '',
        };
    }
    componentDidMount() {
   console.log("userinfo",this.props.user_id)
        if (sessionStorage.getItem('adminDetails') !== undefined && sessionStorage.getItem('adminDetails') !== null) {
            this.getUsersDetail();
        } else {
            window.location.replace("/admin-login");
        }
    }
    componentDidUpdate() {

    }

    getUsersDetail = async () => {
        let postData = {
            token: JSON.parse(sessionStorage.getItem('adminDetails')).token,
            uuid: this.props.user_id
        }
    
        const result = await apiClient('user-detail', {
            method: 'POST',
            body: postData
        });

        const res = await result.json();

        if (result.status === 200) {
            let user = res.data
            console.log("detail", res.data)
           
            this.setState({
                age: user.age,
                gender: user.gender,
                name: user.name,
                phone: user.phone,
            })
        } else {
            toast.error(res.ResponseText, {
                position: toast.POSITION.TOP_CENTER,
            });
        }
    }

    render() {
        const { pageSize } = this.state
        return (<>
            <div className="page_content">
                <section className="upper_section">
                    <div className="page_heading row">
                        <h3><span className="title">Users Detail</span></h3>
                        <div className="page_actions">

                        </div>
                    </div>
                </section>
                <section className="lower_section">
                    <div className="row">
                        <div className="col-md-8 offset-md-2 mt-5">
                            <form className="formInline">
                                <div className="form-group row">
                                    <label className="col-md-2 label-inline"></label>
                                    <div className="col-md-12">


                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </section>
            </div>
            
        </>)
    }
}
export default UserInfo